import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import * as columnFormatters from '../../../../../../components/SelectProduct/List/column-formatters';

export const ITEMS_URL = '/stocks';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      let cost0 = parseFloat('0.00');
      return {
        items: action.payload.items.map((item) => {
          let stockQty = action.payload.stock.rest * item.qtyInSet;
          let totalCost = item.cost
            ? Math.round((item.cost * item.qtyInSet + Number.EPSILON) * 100) /
              100
            : parseFloat('0');
          cost0 = cost0 + totalCost;
          const updatedItem = {
            ...item,
            totalCost: totalCost,
            qty: stockQty,
            totalQty: stockQty + item.productCount,
          };

          return updatedItem;
        }),
        calcCost: Math.round((cost0 + Number.EPSILON) * 100) / 100,
      };
    case 'setCost':
      let cost1 = parseFloat('0.00');
      return {
        items: state.items.map((item) => {
          /*     console.log(
            'setCost: ',
            action.payload.product,
            action.payload.stock,
            action.payload.newCost
          ); */

          if (item.productCode === action.payload.product.productCode) {
            console.log('action.payload.newCost=', action.payload.newCost);
            let s = action.payload.newCost.replace(/[^\d\.\-]/g, '');
            let cost = parseFloat(s);
            //console.log('cost=', cost);
            let totalCost =
              Math.round((cost * item.qtyInSet + Number.EPSILON) * 100) / 100;
            cost1 = cost1 + totalCost;
            const updatedItem = {
              ...item,
              cost: cost,
              totalCost: totalCost,
            };

            return updatedItem;
          }
          cost1 =
            cost1 +
            Math.round((item.cost * item.qtyInSet + Number.EPSILON) * 100) /
              100;
          return item;
        }),
        calcCost: Math.round((cost1 + Number.EPSILON) * 100) / 100,
      };
    default:
      console.log('Wrong Dispatch: ', action);
  }
}
export default function StockItems(props) {
  const { stock, extractStock } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, { items: [] });

  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'qtyInSet',
      text: 'Unit Qty',
      sort: false,
      //formatter: ProductQuantityColumnFormatter,
      classes: 'text-center',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '90px',
      },
    },
    {
      dataField: 'productPrice',
      text: 'Unit Price',
      sort: false,
      formatter: DecimalColumnFormatter,
      classes: 'text-center',
      headerClasses: 'text-center',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    {
      dataField: 'productWeight',
      text: 'Unit Weight',
      sort: false,
      classes: 'text-center',
      headerClasses: 'text-center',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '80px',
        width: '90px',
      },
    },

    {
      dataField: 'cost',
      text: 'Unit cost',
      sort: false,
      classes: 'text-right pr-0',
      formatter: CostColumnFormatter,
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },

    {
      dataField: 'totalCost',
      text: 'Total Cost',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },
    {
      dataField: 'qty',
      text: 'Extract Qty',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: DecimalColumnFormatter,
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },
    {
      dataField: 'productCount',
      text: 'Current Qty',
      sort: false,
      //formatter: ProductQuantityColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '80px',
        width: '90px',
      },
    },
    {
      dataField: 'totalQty',
      text: 'Total Qty',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '100px',
        width: '120px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(ITEMS_URL, stock.id, { headers: { action: 'getstockitems' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('StockItems: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({
              type: 'init',
              payload: { items: response.data.data, stock: stock },
            });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [stock]);

  useEffect(() => {
    console.log('StockItems.STATE', state);
  }, [state]);

  const save = () => {
    setLoading(true);
    axios
      .post(
        ITEMS_URL,
        {
          stockId: stock.id,
          items: state.items,
          newQty: stock.rest, // change to newQty when newQty is provided
        },
        { headers: { action: 'extract' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
            setError('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            extractStock(state.items);
            break;
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            extractStock(state.items);
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const setCost = (row, e) => {
    dispatch({
      type: 'setCost',
      payload: { product: row, stock: stock, newCost: e },
    });
  };

  function CostColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`productCost_${row.productCode}`}
        name='cost'
        value={cellContent}
        onBlur={(e) => {
          setCost(row, e);
        }}
        className='form-control form-control-sm'
        negative={false}
        prefix=''
        decimalScale='0'
        fixedDecimalScale={false}
        defaultValue='0'
      />
    );
  }

  function DecimalColumnFormatter(cellContent, row) {
    return (
      <div>
        {cellContent
          ? cellContent
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
          : '0.00'}
      </div>
    );
  }

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}

      <Card id='stockItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Items - ${totalCount}`}>
          <CardHeaderToolbar>
            <>
              {stock && stock.cost === state.calcCost ? (
                <span style={{ color: 'blue' }}>{state.calcCost}</span>
              ) : (
                <span style={{ color: 'red' }}>{state.calcCost}</span>
              )}
              {stock ? (
                <button
                  type='button'
                  className='btn btn-info ml-2'
                  onClick={save}
                >
                  {stock.rest > 0 ? (
                    <FormattedMessage id='STOCK.BUTTON.EXTRACT' />
                  ) : (
                    <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  )}
                  {loading && (
                    <span
                      id='orderItemsSave'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              ) : (
                <></>
              )}
            </>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={false}
            local
            keyField='productCode'
            data={state.items === null ? [] : state.items}
            columns={columns}
          >
            <PleaseWaitMessage entities={state.items} />
            <NoRecordsFoundMessage entities={state.items} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
